import request from '../request.js'

// 获取用户组角色信息（张卫华）
const getAllList = function (data) {
    return request({
        url: 'sysGroupInnerRole/getAllList',
        method: 'post',
        data
    })
};

// 获取用户组角色信息（张卫华）
const getProjectRoles = function (data) {
    return request({
        url: 'sysGroupInnerRole/getProjectRoles',
        method: 'post',
        data
    })
}
// 获取预设角色信息（张卫华）
const getPreinstallAllList = function (data) {
    return request({
        url: 'sysGroupInnerRole/getPreinstallAllList',
        method: 'post',
        data
    })
}

// 保存/修改
const saveOrUpdate = function (data) {
    return request({
        url: 'sysGroupInnerRole/saveOrUpdate',
        method: 'post',
        data
    })
}
// 保存/修改预设角色
const saveOrUpdatePreinstall = function (data) {
    return request({
        url: 'sysGroupInnerRole/saveOrUpdatePreinstall',
        method: 'post',
        data
    })
}


// 根据id，获取角色信息（张卫华）
const getInfoById = function (data) {
    return request({
        url: 'sysGroupInnerRole/getInfoById',
        method: 'post',
        data
    })
}

// 根据id，删除角色信息（张卫华）
const deletePlus = function (data) {
    return request({
        url: 'sysGroupInnerRole/deletePlus',
        method: 'post',
        data
    })
}
// 根据id，删除预设角色信息（张卫华）
const deletePreinstall = function (data) {
    return request({
        url: 'sysGroupInnerRole/deletePreinstall',
        method: 'post',
        data
    })
}

export {
    getAllList,
    getProjectRoles,
    saveOrUpdate,
    getInfoById,
    deletePlus,
    saveOrUpdatePreinstall,
    getPreinstallAllList,
    deletePreinstall,
}